const isDarkColor = (hexColor: string): boolean => {
  // https://stackoverflow.com/a/8027444
  if (!/^#[0-9A-F]{6}$/i.test(hexColor)) {
    throw new Error(
      `${hexColor} is not a valid hexadecimal color representation`,
    );
  }
  const rgb = parseInt(hexColor.split('#')[1], 16); // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff; // extract red
  const g = (rgb >> 8) & 0xff; // extract green
  const b = (rgb >> 0) & 0xff; // extract blue

  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

  return luma < 150;
};

export default isDarkColor;
